import { SecuredClient } from 'Core/Api/SecuredClient';
import { CancelToken } from 'axios';

// Singleton client instance - avoids creating new instances per request
let clientInstance: SecuredClient | null = null;

const getClient = (): SecuredClient => {
  if (!clientInstance) {
    clientInstance = new SecuredClient();
    clientInstance.handleGeneralError = true;
    clientInstance.showLoading = false;
  }
  return clientInstance;
};

export class DashboardHandler {
  async getDashboardData(cancelToken?: CancelToken) {
    const client = getClient();
    return client.getAdminDashboard(cancelToken);
  }

  async getStatisticData(cancelToken?: CancelToken) {
    const client = getClient();
    return client.getStatisticsForAdminDashboard(cancelToken);
  }

  async getGameHistory(period: string = '30D', cancelToken?: CancelToken) {
    const client = getClient();
    return client.getGameHistory(period, cancelToken);
  }

  async getTopPerformers(period: string, cancelToken?: CancelToken) {
    const client = getClient();
    return client.getTopPerformers(period, cancelToken);
  }

  async getUserCount(cancelToken?: CancelToken) {
    const client = getClient();
    return client.getUserCount(cancelToken);
  }
}

// Export singleton handler instance for convenience
export const dashboardHandler = new DashboardHandler();
